import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getShiftAndHours } from "../services/getData";
import { transformSelectFormat } from "../../../utils/transformFormatSelect";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getLocationsByGroups } from "../../../services/locationsApi";
import { getEquipmentsByType } from "../../../services/equipmentsAPI";
import Header from "../../../components/header";
import {addDays, format, parse, subDays } from "date-fns";
import { insertTravel } from "../services/Insert&UpdateTravel";
import { useValidateProductionInputs } from "../../../hooks/useValidateProductionInputs";
import Swal from "sweetalert2";

const LoadEditorFormExtraload = ({
  title,
  is_automatic,
  is_open,
  allOriginList,
  allDestinationList,
  allTruckList,
  allShovelList,
  AllHourListAux,
  selectedShiftAux,
  allShift,
  allMaterial,
  allMaterialBlock,
  allMaterialClass,
  allPitLevel,
  allRehandle,
  configInputs,
  actualShift,
}) => {
  const [selectedShift, setSelectedShift] = useState([]);

  const [selectedHour, setSelectedHour] = useState([
    { value: "0", label: "Select Shift" },
  ]);
  const [allHourList, setAllHourList] = useState([
    { value: "0", label: "Select Hour" },
  ]);
  const [selectedShiftDate, setSelectedShiftDate] = useState(null);
  const [selectedShiftDatePicker, setSelectedShiftDatePicker] = useState(null);
  const [minSelectedShiftDatePicker, setMinSelectedShiftDatePicker] = useState(null);
  const [maxSelectedShiftDatePicker, setMaxSelectedShiftDatePicker] = useState(null);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [selectedShovel, setSelectedShovel] = useState(null);
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [selectedMaterialBlock, setSelectedMaterialBlock] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedMaterialClass, setSelectedMaterialClass] = useState(null);
  const [selectedPitLevel, setSelectedPitLevel] = useState(null);
  const [selectedRehandle, setSelectedRehandle] = useState(null);
  const [selectedDensity, setSelectedDensity] = useState(0);
  const [selectedGrade1, setSelectedGrade1] = useState(0);
  const [selectedGrade2, setSelectedGrade2] = useState(0);
  const [selectedDistance, setSelectedDistance] = useState(0);
  const [selectedTotalTravels, setSelectedTotalTravels] = useState(1);

  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [cleanForm, setCleanForm] = useState(false);
  //console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
  //console.log(configInputs)
  //console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')

  useEffect(() => {
    (async () => {
      if (!selectedShiftAux || !actualShift) return;
      setMostrarFormulario(is_open);
      //console.log("La fecha actual es:", actualShift);
      setSelectedShiftDate(actualShift);
      const safeDate = parse(actualShift, "yyyy-MM-dd", new Date());
      setSelectedShiftDatePicker(safeDate);
      
      const minDate = subDays(safeDate, configInputs.shift_date.min_value);
      //console.log('La fecha minima es: ' , minDate);
      setMaxSelectedShiftDatePicker(safeDate)
      setMinSelectedShiftDatePicker(minDate)


      setAllHourList(AllHourListAux);
      //console.log("--------");
      //console.log(selectedShiftAux);
      //console.log("--------");
      setSelectedShift(selectedShiftAux);
    })();
  }, [selectedShiftAux, cleanForm, configInputs]);

  const handleShift = async (selectedOption) => {
    //console.log("Entro al cambio");
    const new_shift = selectedOption ? selectedOption.value : "";
    //console.log("Categoría seleccionada:", new_shift);
    const result_shift = await getShiftAndHours(null, new_shift);
    if (result_shift) {
      //console.log('sssssssssssssssssssssss')
      //console.log(result_shift);
      //console.log('sssssssssssssssssssssss')
      const select_shift_hour = transformSelectFormat(
        result_shift.shift_info,
        "hsl_column",
        "hsl_hour"
      );
      if (select_shift_hour.status == 200) {
        setAllHourList(select_shift_hour.data);
        setSelectedShift(selectedOption);
      }
    }
  };

  const toggleFormulario = () => {
    setMostrarFormulario((prev) => !prev);
  };

  const SaveTravel = async () => {
    //console.log("El registro se va a guardar");
    let errors = [];
    //console.log(selectedOrigin);
    //console.log(selectedTruck);
    const inputs_check = {
      date: selectedShiftDate,
      shift: selectedShift,
      hour: selectedHour,
      truck: selectedTruck,
      origin: selectedOrigin,
      destination: selectedDestination,
      shovel: selectedShovel,
      material: selectedMaterial,
      rehandle: selectedRehandle,
      material_block: selectedMaterialBlock,
      material_class: selectedMaterialClass,
      pit_level: selectedPitLevel,
      density: selectedDensity,
      grade1: selectedGrade1,
      grade2: selectedGrade2,
    };
    const result_validate = useValidateProductionInputs(
      configInputs,
      inputs_check
    );
    //console.log(result_validate);
    if (result_validate.length > 0) {
      //console.log(result_validate);
      let result_error = await Swal.fire({
        title: "Conflicts when inserting travels",
        icon: "error",
        text: "All fields must be entered",
        confirmButtonColor: "#3085d6",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
        },
        buttonsStyling: false,
      });
    } else {
      //console.log("Se puede insertar");
      const inputs_insert = {
        date: selectedShiftDate,
        shift: selectedShift?.value,
        hour: selectedHour?.value,
        truck: selectedTruck?.value,
        origin: selectedOrigin?.value,
        destination: selectedDestination?.value,
        shovel: selectedShovel?.value,
        material: selectedMaterial?.value,
        rehandle: selectedRehandle?.value,
        material_block: selectedMaterialBlock?.value,
        material_class: selectedMaterialClass?.value,
        pit_level: selectedPitLevel?.value,
        density: selectedDensity,
        grade1: selectedGrade1,
        grade2: selectedGrade2,
        distance: selectedDistance,
      };
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "The travels will be entered into the system",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, save",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
          cancelButton:
            "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded ml-2",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        const resultInsert = await insertTravel(
          inputs_insert,
          is_automatic,
          selectedTotalTravels,
          configInputs
        );
        //console.log(resultInsert);
        if (resultInsert.status == 200) {
          let result_correct = await Swal.fire({
            title: "The travels were inserted",
            icon: "success",
            confirmButtonColor: "#3085d6",
            customClass: {
              confirmButton:
                "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
            },
            buttonsStyling: false,
          });
          if (result_correct.isConfirmed) {
            //console.log("Se debe recargar el formulario");
            setSelectedShiftDate(null);
            setSelectedHour(null);
            setSelectedShiftDatePicker(null);
            setSelectedTruck(null);
            setSelectedShovel(null);
            setSelectedOrigin(null);
            setSelectedDestination(null);
            setSelectedMaterialBlock(null);
            setSelectedMaterial(null);
            setSelectedMaterialClass(null);
            setSelectedPitLevel(null);
            setSelectedRehandle(null);
            setSelectedDensity(0);
            setSelectedGrade1(0);
            setSelectedGrade2(0);
            setSelectedDistance(0);
            setSelectedTotalTravels(1);
            setCleanForm(!cleanForm);
          }
        } else {
          //console.log(resultInsert.error);
          let result_error = await Swal.fire({
            title: "The travels were not inserted",
            icon: "error",
            confirmButtonColor: "#3085d6",
            customClass: {
              confirmButton:
                "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
            },
            buttonsStyling: false,
          });
        }
      }
    }
  };

  const handleDateFilter = async (event) => {
    //console.log("Se va a filtrar fecha");
    //console.log(event);
    let formatted = format(event, "yyyy-MM-dd");
    //console.log(formatted);
    setSelectedShiftDate(formatted);
    setSelectedShiftDatePicker(event);
  };

  return (
    <div class="m-10 bg-gray-300">
      <h2
        onClick={toggleFormulario}
        className="cursor-pointer text-xl font-bold text-blue-600 mb-2"
      >
        <Header title={title} />
      </h2>
      {mostrarFormulario && (
        <div>
          <div>
            <div class="mx-2 my-5 grid grid-cols-12 gap-4">
              {!is_automatic && (
                <div class={`${is_automatic ? "col-span-2" : "col-span-1"}`}>
                  <label class=" tracking-wide text-xs font-bold mb-2">
                    Date Shift
                  </label>
                  <DatePicker
                    selected={selectedShiftDatePicker}
                    onChange={(date) => handleDateFilter(date)}
                    minDate={minSelectedShiftDatePicker}
                    maxDate={maxSelectedShiftDatePicker}
                    dateFormat="yyyy/MM/dd"
                    placeholderText="YYYY/MM/DD"
                    className="!w-full border border-gray-300 rounded-md px-0 py-1.5"
                    wrapperClassName="w-full"
                  />
                </div>
              )}

              <div class={`${is_automatic ? "col-span-2" : "col-span-1"}`}>
                <label class=" tracking-wide text-xs font-bold mb-2">
                  Shift
                </label>
                <Select
                  value={selectedShift}
                  onChange={(selectedOption) => handleShift(selectedOption)}
                  options={allShift}
                  isDisabled={is_automatic}
                />
              </div>
              <div class="col-span-2">
                <label class="tracking-wide text-xs font-bold mb-2">Hour</label>
                <Select
                  value={selectedHour}
                  onChange={setSelectedHour}
                  options={allHourList}
                />
              </div>
              <div class="col-span-2">
                <label class="tracking-wide text-xs font-bold mb-2">
                  Truck
                </label>
                <Select
                  value={selectedTruck}
                  onChange={setSelectedTruck}
                  options={allTruckList}
                />
              </div>
              <div class="col-span-2">
                <label class=" tracking-wide text-xs font-bold mb-2">
                  Shovel
                </label>
                <Select
                  value={selectedShovel}
                  onChange={setSelectedShovel}
                  options={allShovelList}
                />
              </div>
              <div class="col-span-2">
                <label class=" tracking-wide text-xs font-bold mb-2">
                  Origin
                </label>
                <Select
                  value={selectedOrigin}
                  onChange={setSelectedOrigin}
                  options={allOriginList}
                />
              </div>
              <div class="col-span-2">
                <label class=" tracking-wide text-xs font-bold mb-2">
                  Destination
                </label>
                <Select
                  value={selectedDestination}
                  onChange={setSelectedDestination}
                  options={allDestinationList}
                />
              </div>
            </div>
          </div>
          <div>
            <div class="mx-2 my-5 grid gap-4  grid-cols-[repeat(auto-fit,minmax(110px,1fr))]">
              {configInputs.material_block.is_show && (
                <div class="col-span-2">
                  <label class="tracking-wide text-xs font-bold mb-2">
                    Material Block
                  </label>
                  <Select
                    value={selectedMaterialBlock}
                    onChange={setSelectedMaterialBlock}
                    options={allMaterialBlock}
                  />
                </div>
              )}
              <div class="col-span-2">
                <label class="tracking-wide text-xs font-bold mb-2">
                  Material
                </label>
                <Select
                  value={selectedMaterial}
                  onChange={setSelectedMaterial}
                  options={allMaterial}
                />
              </div>
              {configInputs.material_class.is_show && (
                <div class="col-span-2">
                  <label class=" tracking-wide text-xs font-bold mb-2">
                    Material Class
                  </label>
                  <Select
                    value={selectedMaterialClass}
                    onChange={setSelectedMaterialClass}
                    options={allMaterialClass}
                  />
                </div>
              )}
              {configInputs.pit_level.is_show && (
                <div class="col-span-2">
                  <label class=" tracking-wide text-xs font-bold mb-2">
                    Pit Level
                  </label>
                  <Select
                    value={selectedPitLevel}
                    onChange={setSelectedPitLevel}
                    options={allPitLevel}
                  />
                </div>
              )}
              {configInputs.density.is_show && (
                <div class="col-span-2">
                  <label class=" tracking-wide text-xs font-bold mb-2">
                    Density
                  </label>
                  <input
                    type="number"
                    readOnly={true}
                    aria-describedby="helper-text-explanation"
                    class="border border-gray-300 text-gray-900 text-sm rounded-md focus:border-blue-500 block w-full p-2"
                    value={selectedDensity}
                    step={0.01}
                    onChange={(e) => setSelectedDensity(Number(e.target.value))}
                  />
                </div>
              )}
              {configInputs.rehandle.is_show && (
                <div class="col-span-2">
                  <label class=" tracking-wide text-xs font-bold mb-2">
                    Reh
                  </label>
                  <Select
                    value={selectedRehandle}
                    onChange={setSelectedRehandle}
                    options={allRehandle}
                  />
                </div>
              )}
              {configInputs.grade1.is_show && (
                <div class="col-span-2">
                  <label class=" tracking-wide text-xs font-bold mb-2">
                    Grade
                  </label>
                  <input
                    type="number"
                    aria-describedby="helper-text-explanation"
                    class="border border-gray-300 text-gray-900 text-sm rounded-md focus:border-blue-500 block w-full p-2"
                    value={selectedGrade1}
                    min={configInputs.grade1.min_value}
                    max={configInputs.grade1.max_value}
                    step={0.01}
                    onChange={(e) => setSelectedGrade1(Number(e.target.value))}
                  />
                </div>
              )}
              {configInputs.grade2.is_show && (
                <div class="col-span-2">
                  <label class=" tracking-wide text-xs font-bold mb-2">
                    Grade Two
                  </label>
                  <input
                    type="number"
                    aria-describedby="helper-text-explanation"
                    min={configInputs.grade2.min_value}
                    max={configInputs.grade2.max_value}
                    class="border border-gray-300 text-gray-900 text-sm rounded-md focus:border-blue-500 block w-full p-2"
                    value={selectedGrade2}
                    step={0.01}
                    onChange={(e) => setSelectedGrade2(Number(e.target.value))}
                  />
                </div>
              )}
            </div>
            <div className="mx-2 my-5 grid gap-4  grid-cols-[repeat(auto-fit,minmax(110px,1fr))]">
              <div class="col-span-2">
                <label class=" tracking-wide text-xs font-bold mb-2">
                  Distance
                </label>
                <input
                  type="number"
                  aria-describedby="helper-text-explanation"
                  class="border border-gray-300 text-gray-900 text-sm rounded-md focus:border-blue-500 block w-full p-2"
                  value={selectedDistance}
                  step={0.1}
                  min={0}
                  onChange={(e) => setSelectedDistance(Number(e.target.value))}
                />
              </div>
              <div class="col-span-2">
                <label class=" tracking-wide text-xs font-bold mb-2">
                  Quantity
                </label>
                <input
                  type="number"
                  aria-describedby="helper-text-explanation"
                  class="border border-gray-300 text-gray-900 text-sm rounded-md focus:border-blue-500 block w-full p-2"
                  value={selectedTotalTravels}
                  step={1}
                  min={1}
                  max={100}
                  onChange={(e) =>
                    setSelectedTotalTravels(Number(e.target.value))
                  }
                />
              </div>
              <div class="col-span-2">
                <button
                  className="w-4/5  bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded m-5"
                  onClick={SaveTravel}
                >
                  Save Travel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadEditorFormExtraload;
